"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrapiQueryBuilder = void 0;
const helpers_1 = require("./helpers");
const strapi_client_helper_1 = require("./strapi-client-helper");
const strapi_filter_builder_1 = require("./strapi-filter-builder");
class StrapiQueryBuilder extends strapi_client_helper_1.StrapiClientHelper {
    constructor(url, axiosInstance, isNotUserContent, normalizeData, debug) {
        super(url);
        this.debug = debug;
        this.normalizData = normalizeData;
        this.url = `${url}`;
        this.isNotUserContent = isNotUserContent;
        this.httpClient = axiosInstance;
    }
    /**
     *
     * @param fields Array of string to select the fields.
     * @returns collection of requested contents.
     */
    select(fields) {
        if (fields) {
            const query = {
                fields,
            };
            const queryString = (0, helpers_1.generateQueryString)(query);
            this.url = `${this.url}?${queryString}`;
        }
        return new strapi_filter_builder_1.StrapiFilterBuilder(this.url, this.httpClient, this.normalizData, this.debug, this.isNotUserContent);
    }
    /**
     *
     * @param ids Array of string or number values to select many records.
     * @returns selected contents.
     */
    selectManyByID(ids) {
        if (ids) {
            const query = ids === null || ids === void 0 ? void 0 : ids.map((item) => `filters[id][$in]=${item}`).join('&');
            this.url = `${this.url}?${query}`;
        }
        return new strapi_filter_builder_1.StrapiFilterBuilder(this.url, this.httpClient, this.normalizData, this.debug, this.isNotUserContent);
    }
    /**
     *
     * @param values The values to create a new record.
     * @returns By default the new record is returned.
     */
    async create(values) {
        return new Promise((resolve) => {
            this.httpClient
                .post(this.url, this._handleValues(values))
                .then((res) => {
                resolve(this.normalizData ? this._returnDataHandler(res.data) : res.data);
            })
                .catch((err) => {
                if (err) {
                    resolve(this._returnErrorHandler(err));
                }
            });
        });
    }
    /**
     *
     * @param values objects of values to create many records.
     * @returns return boolean value if the process on success
     */
    async createMany(values) {
        await Promise.all(values.map(async (value) => {
            const { data } = await this.httpClient.post(this.url, this._handleValues(value));
            return Promise.resolve(data);
        })).catch((error) => {
            if (error) {
                this._returnErrorHandler(error);
            }
        });
        return Promise.resolve({
            success: true,
        });
    }
    /**
     *
     * @param values The values to update an existing record.
     * @returns By default the new record is returned.
     */
    async update(id, values) {
        const url = `${this.url}/${id}`;
        return new Promise((resolve) => {
            this.httpClient
                .put(url, this._handleValues(values))
                .then((res) => {
                resolve(this.normalizData ? this._returnDataHandler(res.data) : res.data);
            })
                .catch((err) => {
                if (err) {
                    resolve(this._returnErrorHandler(err));
                }
            });
        });
    }
    /**
     *
     * @param values objects of values to update many records.
     * @returns return boolean value if the process on success
     */
    async updateMany(values) {
        await Promise.all(values.map(async (value) => {
            const url = `${this.url}/${value.id}`;
            const { data } = await this.httpClient.put(url, this._handleValues(value.variables));
            return Promise.resolve(data);
        })).catch((error) => {
            if (error) {
                this._returnErrorHandler(error);
            }
        });
        return Promise.resolve({
            success: true,
        });
    }
    /**
     *
     * @param value The value to delete an record.
     * @returns By default the deleted record is returned.
     */
    async deleteOne(id) {
        const url = `${this.url}/${id}`;
        return new Promise((resolve) => {
            this.httpClient
                .delete(url)
                .then((res) => {
                resolve(res.data);
            })
                .catch((err) => {
                if (err) {
                    resolve(this._returnErrorHandler(err));
                }
            });
        });
    }
    /**
     *
     * @param values Array of string or number values to delete many records.
     * @returns return boolean value if the process on success
     */
    async deleteMany(ids) {
        await Promise.all(ids.map(async (id) => {
            const { data } = await this.httpClient.delete(`${this.url}/${id}`);
            return data;
        })).catch((err) => {
            if (err) {
                return this._returnErrorHandler(err);
            }
        });
        return Promise.resolve({
            success: true,
        });
    }
    _handleValues(values) {
        if (this.isNotUserContent) {
            const dataValues = {
                data: values,
            };
            return dataValues;
        }
        else {
            return values;
        }
    }
}
exports.StrapiQueryBuilder = StrapiQueryBuilder;
